import React from 'react';
import {
    TextStyle,
    ResourceItem,
    ResourceList,
    Card,
    Stack,
    Thumbnail
} from '@shopify/polaris';
import { GenieTag, ToGenieTag } from '../components/GenieTag';

function OperationPreviewComponent(props) {

    function renderPreviewItems(item) {
        const { id, productName, productImage, tags } = item;

        return (
            <ResourceItem id={id} url={null} media={
                <Thumbnail source={productImage} alt="image" />
            }>
                <h3 className="previewProductTitle">
                    <TextStyle variation="strong">{productName}</TextStyle>
                </h3>
                <Stack spacing="tight" distribution="leading" alignment="leading">{ToGenieTag(tags)}</Stack>
            </ResourceItem>
        );
    }

    let previewItems = props.preview.resourcePreviews.map((item, index) => {
        return {
            id: index,
            url: null,
            productName: item.title,
            productImage: item.image,
            tags: item.tags,
        }
    });

    let preview = (<div>Currently, no tags will be affected by this operation!</div>);
    let hasTagActions = props.preview.resourcePreviews.length > 0;
    let addedTags = props.preview.addedTags.map((item) => <GenieTag selectable={false} state="added">{item}</GenieTag>);
    let removedTags = props.preview.removedTags.map((item) => <GenieTag selectable={false} state="removed">{item}</GenieTag>);

    if (hasTagActions) {
        preview = (<div>
            <p><TextStyle variation="strong">{props.preview.resourcePreviews.length}</TextStyle> {props.resourcePlural} will be affected by this operation with <TextStyle variation="strong">{props.preview.affectedTagsCount}</TextStyle> tag changes.</p>
        </div>)
    }

    return (
        <React.Fragment>
            <Card.Section>
                {preview}
            </Card.Section>
            <Card.Section title="Tags to be added">
                {addedTags.length > 0 && <Stack alignment="center">{addedTags}</Stack>}
                {addedTags.length === 0 && <span>None</span>}
            </Card.Section>
            <Card.Section title="Tags to be removed">
                {removedTags.length > 0 && <Stack alignment="center">{removedTags}</Stack>}
                {removedTags.length === 0 && <span>None</span>}
            </Card.Section>
            <Card.Section title={props.resourceSingular + " tag changes"}>
                <ResourceList
                    resourceName={{ singular: props.resourceSingular, plural: props.resourcePlural }}
                    items={previewItems}
                    renderItem={renderPreviewItems}
                />
            </Card.Section>
        </React.Fragment>
    );
}

OperationPreviewComponent.defaultProps = {
    preview: {
        resources: [],
        canExecute: false,
        actionCreditsCost: 0,
        affectedTagsCount: 0,
        remainingActionCredits: 0,
        removedTags: [],
        addedTags: []
    },
    resourcePlural: "products",
    resourceSingular: "product",
    onSubmitOperation: () => { },
    onEditOperation: () => { },
}

export default OperationPreviewComponent;